import { useAsync } from '../../data/useAsync';
import { useSession } from '../../state/session';
import { currencyGroups } from './currencies';

/**
 * The books' own currency and the ones the business deals in (chosen on
 * Settings → Currencies, plus any already in use), for ordering pickers.
 */
export function useYourCurrencies(): { base: string; yours: string[] } {
  const { source, context } = useSession();
  const fx = useAsync(() => source.fxOverview(), [source]);
  const base = context?.organisation.base_currency ?? 'EUR';
  if (fx.state !== 'ready') return { base, yours: [] };
  const yours = [...fx.data.chosen, ...fx.data.currencies.filter((x) => x.in_use).map((x) => x.code)];
  return { base: fx.data.base_currency, yours: [...new Set(yours)].filter((x) => x !== fx.data.base_currency) };
}

/** <option>s for a currency <select>, grouped: yours first, then every other currency by region. */
export function CurrencyOptions({ base, yours }: { base: string; yours: string[] }) {
  return (
    <>
      {currencyGroups(base, yours).map((g) => (
        <optgroup key={g.label} label={g.label}>
          {g.options.map((x) => <option key={x.code} value={x.code}>{x.code} · {x.name}</option>)}
        </optgroup>
      ))}
    </>
  );
}
